<template>
  <section class="app-loading section-box">
    <div>
      <v-progress-circular color="deep-orange darken-2" indeterminate></v-progress-circular>
    </div>
    <div>carregando...</div>
  </section>
</template>

<script>
export default {
  name: 'AppLoading'
}
</script>

<style>
  .app-loading {
    padding: 40px 0;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/modules/AppLoading.vue